document.addEventListener('DOMContentLoaded', function() {
   var client_id = document.getElementById("clientinfo").getAttribute('data-id');
   loadData();
   formDataLoad('Catalogue');
   formDataLoad('Pricelist');
   formDataLoad('Stockist');
   formDataLoad('General');
 
   function loadData() {
     fetch('https://bukio.io/admin/api/load-configuration/' + client_id)
       .then(response => response.json())
       .then(res => {
         //console.log(res);
         generalFormSettings(res.data[0],res.icon_picuture);
       })
       .catch(error => {
         console.log("Setting - Something went wrong");
       });
   }
 
   function formDataLoad(ftype) {
     fetch('https://bukio.io/admin/api/load-form/' + client_id + '/' + ftype)
       .then(response => response.json())
       .then(res => {
         //console.log(res);
         if (res.data.length) {
           formSettings(res.data[0], ftype);
         }else{
            var button = document.getElementById("cybr_button_" + ftype);
            button.remove();
          }
       })
       .catch(error => {
         console.log("Load Data - Something went wrong");
       });
   }
 
   function generalFormSettings(info,icon_picture) {
     console.log(info.ButtonPosition);
     var chatButton = document.getElementById("chatButton");
     if(info.status == 0){
        chatButton.remove();
        return false;
      }
     chatButton.className = info.ButtonPosition;
     document.getElementById('icon_chat').src=icon_picture;
     document.getElementById("cybr_general_main_container").style.backgroundColor = info.BackgroundColor;
     document.getElementById("cybr_general_heading").style.color = info.HeadingTextColor;
     document.getElementById("cybr_general_heading").textContent = info.HeadingText;
     document.getElementById("cybr_general_content").textContent = info.HeadingContent;
     document.getElementById("cybr_general_content").style.color = info.HeadingContentColor;
     document.getElementById("closePopup").style.color = info.Cross_Color;
     document.getElementById("closePopup").style.backgroundColor = info.Arrow_BackgroundColor;
 
     var vtButton = document.getElementById("cyber_vt_button");
     if(info.linkstatus == 0){
        vtButton.remove();
        return false;
      }
     vtButton.style.backgroundColor = info.TmcBackgroundColor;
     vtButton.style.color = info.TmcTextColor;
     vtButton.textContent = info.TmcText;
     vtButton.setAttribute('href', info.TmcLink);
   }
 
   function formSettings(info, ftype) {
     var button = document.getElementById("cybr_button_" + ftype);
     if(info.status == 0){
        button.remove();
        return false;
      }
     button.textContent = info.FormName;
     var container = document.getElementById("cybr_" + ftype + "_container");
     container.style.backgroundColor = info.BackgroundColor;
     var svg = container.querySelector('.back');
     svg.style.backgroundColor = info.Arrow_BackgroundColor;
     var path = container.querySelector('path');
     path.setAttribute('fill', info.Arrow_Color);
     path.setAttribute('stroke', info.Arrow_Color);
     
     var closeButton = container.querySelector('.close');
      closeButton.style.backgroundColor = info.Arrow_BackgroundColor;
      var closePath =closeButton.querySelector('path');
      closePath.setAttribute('fill', info.Cross_Color);
      closePath.setAttribute('stroke', info.Cross_Color);
 
     var thankContainer = document.getElementById("cybr_" + ftype + "_thank_container");
     var thankSvg = thankContainer.querySelector('.back');
     thankSvg.style.backgroundColor = info.Arrow_BackgroundColor;
 
     var thankPath = thankContainer.querySelector('path');
     thankPath.setAttribute('fill', info.Arrow_Color);
     var thankCloseButton = thankContainer.querySelector('.close');
     thankCloseButton.style.color = info.Cross_Color;
     thankCloseButton.style.backgroundColor = info.Arrow_BackgroundColor;
 
     button.style.color = info.Front_Button_TextColor;
     button.style.backgroundColor = info.Front_Button_BackgroundColor;

 
     var heading = document.getElementById("cybr_" + ftype + "_heading");
     heading.style.color = info.HeadingTextColor;
     heading.textContent = info.HeadingText;
     var content = document.getElementById("cybr_" + ftype + "_content");
     content.textContent = info.HeadingContent;
     content.style.color = info.HeadingContentColor;
 
     if(info.FirstName!=null){
       document.getElementById("cybr_" + ftype + "_form_firstname").setAttribute('placeholder', info.FirstName);
     }
     if(info.LastName!=null){
       document.getElementById("cybr_" + ftype + "_form_lasttname").setAttribute('placeholder', info.LastName);
     }
     if(info.Email!=null){
       document.getElementById("cybr_" + ftype + "_form_email").setAttribute('placeholder', info.Email);
     }
     if(info.Contact!=null){
       document.getElementById("cybr_" + ftype + "_form_phone").setAttribute('placeholder', info.Contact);
     }
     if(info.Checkbox!=null){
       document.getElementById("cybr_" + ftype + "_form_checbox").textContent = info.Checkbox;
     } 
     if(info.CompanyName!=null){
       document.getElementById("cybr_" + ftype + "_form_company").setAttribute('placeholder', info.CompanyName);
     } 
     if(info.Message!=null){
       document.getElementById("cybr_" + ftype + "_form_message").setAttribute('placeholder', info.Message);
     }
     
 
     var formButton = document.getElementById("cybr_" + ftype + "_form_button");
     formButton.style.color = info.SubmitButtonTextColor;
     formButton.style.backgroundColor = info.SubmitButtonBGColor;
     formButton.textContent = info.SubmitButtonText;
 
     thankContainer.style.backgroundColor = info.BackgroundColor;
     var thankContent = document.getElementById("cybr_" + ftype + "_thank_content");
     thankContent.style.color = info.ThanksContentText;
     var thankClose = document.getElementById("cybr_" + ftype + "_thank_close");
     thankClose.style.backgroundColor = info.ThanksButtonCloseBGColor;
     thankClose.style.color = info.ThanksButtonCloseTextColor;
     thankClose.textContent = info.ThanksButtonCloseText;
 
     thankContent.innerHTML = info.ThanksContentText;
   }
 
   document.querySelectorAll('.contactForm1').forEach(form => {
    form.onsubmit = function(event) {
      event.preventDefault();
      form.insertAdjacentHTML('beforeend', '<input type="hidden" name="ctype" value="General">');
      form.insertAdjacentHTML('beforeend', '<input type="hidden" name="cid" value="' + client_id + '">');
      sendRequest(new FormData(form), form, '1');
    }
  });

  document.querySelectorAll('.contactForm2').forEach(form => {
    form.onsubmit = function(event) {
      event.preventDefault();
      form.insertAdjacentHTML('beforeend', '<input type="hidden" name="ctype" value="Catalogue">');
      form.insertAdjacentHTML('beforeend', '<input type="hidden" name="cid" value="' + client_id + '">');
      sendRequest(new FormData(form), form, '2');
    }
  });

  document.querySelectorAll('.contactForm3').forEach(form => {
    form.onsubmit = function(event) {
      event.preventDefault();
      form.insertAdjacentHTML('beforeend', '<input type="hidden" name="ctype" value="Pricelist">');
      form.insertAdjacentHTML('beforeend', '<input type="hidden" name="cid" value="' + client_id + '">');
      sendRequest(new FormData(form), form, '3');
    }
  });

  document.querySelectorAll('.contactForm4').forEach(form => {
    form.onsubmit = function(event) {
      event.preventDefault();
      form.insertAdjacentHTML('beforeend', '<input type="hidden" name="ctype" value="Stockist">');
      form.insertAdjacentHTML('beforeend', '<input type="hidden" name="cid" value="' + client_id + '">');
      sendRequest(new FormData(form), form, '4');
    }
  });
 
   function sendRequest(info, form, elemnumber) {
     var successMessage = form.querySelector('.successMessage');
     successMessage.textContent = 'Sending request..';
     successMessage.style.display = 'block';
 
     fetch('https://bukio.io/admin/api/save-request', {
       method: 'POST',
       body: info,
       crossDomain: true,
     })
     .then(response => response.json())
     .then(responseData => {
       console.log(responseData);
       successMessage.style.display = 'none';
       form.closest('.popup').style.display = 'none';
       form.reset();
       document.getElementById('successPopup' + elemnumber).style.display = 'block';
     })
     .catch(error => {
       successMessage.textContent = 'Something went wrong';
     });
   }
 });
 
 
 document.addEventListener('DOMContentLoaded', function () {
       const chatButton = document.getElementById('chatButton');
       const closePopup = document.getElementById('closePopup');
       const chatBoxSec = document.querySelector('body');
 
       // Add event listener to the chat button
       chatButton.addEventListener('click', function () {
          const popup = document.getElementById('popup');
          popup.style.display = 'block';
          chatBoxSec.classList.add('noscroll');
       });
 
       // Add event listener to the close button
       closePopup.addEventListener('click', function () {
          const popup = document.getElementById('popup');
          popup.style.display = 'none';
          chatBoxSec.classList.remove('noscroll');
       });
 
       document.querySelectorAll('.subButton').forEach(button => {
          button.onclick = function () {
             const popupId = button.getAttribute('data-popup');
             document.getElementById('popup').style.display = 'none';
             document.getElementById(popupId).style.display = 'block';
          }
       });
 
       document.querySelectorAll('.close').forEach(closeButton => {
          closeButton.onclick = function () {
             const parentPopup = closeButton.closest('.popup');
             parentPopup.style.display = 'none';
          }
       });
 
       document.querySelectorAll('.back').forEach(backButton => {
          backButton.onclick = function () {
             const backTo = backButton.getAttribute('data-back');
             const currentPopup = backButton.closest('.popup');
             currentPopup.style.display = 'none';
             document.getElementById(backTo).style.display = 'block';
          }
       });
 
       window.onclick = function (event) {
          document.querySelectorAll('.popup').forEach(popup => {
             if (event.target == popup) {
                popup.style.display = 'none';
             }
          });
       };
 
 
 
       const closeSuccessPopup = document.getElementById('closeSuccessPopup');
        
    
        if (closeSuccessPopup) {
            closeSuccessPopup.onclick = function () {
                document.getElementById('successPopup1').style.display = 'none';
                document.getElementById('successPopup2').style.display = 'none';
                document.getElementById('successPopup3').style.display = 'none';
                document.getElementById('successPopup4').style.display = 'none';
            };
        } else {
            
        }
 
    });
 

 
